<div class="wrapper"
    [ngStyle]="{
        'background-image': backgroundPosition === 'fullscreen' && backgroundImage ? 'url(' + backgroundImage + ')' : '',
        'background-color': backgroundColor ? backgroundColor  : '',
        'grid-template-rows': getGridTemplateRows()
    }"
    [ngClass]="{
      'fullscreen': backgroundPosition === 'fullscreen',
      'bg-top': backgroundPosition === 'top',
      'bg-bottom': backgroundPosition === 'bottom',
      'overlay': overlay
    }"
>
  <div *ngIf="backgroundPosition !== 'fullscreen'"
       class="bg-strip"
       [ngStyle]="{
         'background-image': backgroundImage && backgroundSize !== 'auto' ? 'url(' + backgroundImage + ')' : ''
       }"
  >
    <img *ngIf="backgroundImage && backgroundSize === 'auto'" [src]="backgroundImage" alt="" />
  </div>

  <div class="card-content">
    <ng-content></ng-content>
  </div>
</div>
